import Vendor from '@/models/vendor'

export default class VendorFactory {
    static createFromJson(json) {
        return new Vendor(json)
    }
    static createFromJsonArray(jsonArray) {
        const jsonData = []
        jsonArray.forEach(item => {
            jsonData.push(VendorFactory.createFromJson(item))
        })

        return jsonData
    }
}
